import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit} from '@angular/core';
import {createPopper, Instance as PopperInstance} from '@popperjs/core';
import {OffsetModifier} from '@popperjs/core/lib/modifiers/offset';
import {WindowRefService} from '../../../services/window-ref.service';
import {destroy$} from '../../destroyable';

const CURSOR_SAFE_BOTTOM_HEIGHT = 25;
const CURSOR_SAFE_TOP_HEIGHT = CURSOR_SAFE_BOTTOM_HEIGHT / 2; // No need to lift tooltip upper above cursor.
const CURSOR_SAFE_WIDTH = 8;

@Component({
    selector: 'tooltip',
    templateUrl: './tooltip-balloon.component.html',
    styleUrls: ['./tooltip-balloon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TooltipBalloonComponent implements OnInit {

    @Input()
    public tooltip: string;

    @Input()
    public referenceElementRef: ElementRef;

    @Input()
    public mousePosition: {x: number; y: number};

    public readonly destroy$ = destroy$();

    protected popper: PopperInstance;

    constructor(
        public elementRef: ElementRef,
        protected windowRefService: WindowRefService
    ) {}

    public ngOnInit(): void {
        this.initPopper();
    }

    protected initPopper(): void {
        const offsetModifier: Partial<OffsetModifier> = {
            name: 'offset',
            options: {
                offset: [CURSOR_SAFE_WIDTH, CURSOR_SAFE_TOP_HEIGHT]
            }
        };

        if (!this.popper) {
            this.popper = createPopper(
                this.referenceElementRef.nativeElement,
                this.elementRef.nativeElement,
                {
                    placement: 'bottom',
                    modifiers: [
                        offsetModifier
                    ]
                }
            );

            this.popper.update();

            this.destroy$.subscribe(() => this.popper.destroy());
        }
    }

}
